import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Input,
	Form,
} from './formStyles';

import Spinner from 'core/components/Spinner';

class SignupForm extends PureComponent {
	render() {
		const {
			formHandler,
			email,
			inputChangeHandler,
			inputBlurHandler,
			inputFocusHandler,
			emailInvalid,
			loading,
			submitText,
		} = this.props;
		const invalidInputs = emailInvalid;
		const disabled = invalidInputs || loading;

		return (
			<Form action="/handle-subscribe/" onSubmit={formHandler} target="_top">
				<Input
					id="sswEmail"
					placeholder="Email Address"
					type="email"
					name="email"
					value={email}
					onChange={inputChangeHandler}
					onFocus={inputFocusHandler}
					onBlur={inputBlurHandler}
					required
					border
					focusColor={'lavender'}
					errorMsg={emailInvalid ? 'Invalid email' : undefined}
				/>
				<Button type="submit" disabled={disabled}>
					{loading ? <Spinner /> : submitText}
				</Button>
			</Form>
		);
	}

	static propTypes = {
		submitText: PropTypes.string,
		email: PropTypes.string,
		emailInvalid: PropTypes.bool,
		inputChangeHandler: PropTypes.func,
		inputBlurHandler: PropTypes.func,
		inputFocusHandler: PropTypes.func,
		formHandler: PropTypes.func,
		loading: PropTypes.bool,
	}
}

export default SignupForm;
